import * as React from 'react';

function SvgOverviewIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.333 7.333l-5.5-4.821a2.75 2.75 0 00-3.666 0l-5.5 4.821a2.75 2.75 0 00-.917 2.072v8.012a2.75 2.75 0 002.75 2.75h11a2.75 2.75 0 002.75-2.75V9.396a2.75 2.75 0 00-.917-2.063zm-5.5 11H9.167V13.75a.917.917 0 01.916-.917h1.834a.917.917 0 01.916.917v4.583zm4.584-.916a.917.917 0 01-.917.916h-1.833V13.75a2.75 2.75 0 00-2.75-2.75h-1.834a2.75 2.75 0 00-2.75 2.75v4.583H5.5a.916.916 0 01-.917-.916V9.396a.917.917 0 01.312-.688l5.5-4.812a.917.917 0 011.21 0l5.5 4.812a.917.917 0 01.312.688v8.02z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgOverviewIcon;
